import {RootScope} from '../types/angular-types';
import * as _ from 'lodash-es';
import '../services/OneTimeInitializationService';
import {OneTimeInitializationService} from '../services/OneTimeInitializationService';
import * as angular from 'angular';

angular.module('GorillaBoy.Login')
    .controller('LoginController', [
        '$routeParams',
        '$location',
        '$window',
        '$log',
        '$rootScope',
        'AuthService',
        'RegionService',
        'EndpointService',
        'localStorageService',
        'authenticatedUser',
        'UserService',
        'OrganizationService',
        'AppConstants',
        'ClientMetricsService',
        'BrowserService',
        'MetricEvents',
        'OneTimeInitializationService',
        '$q',
        'FeatureManagerService',
        'Features',
        LoginController
    ]);

    var LOGINV2_FEATURE_CONFIG = {
        'dev': {
            globalEnabled: false,
            orgNames : []
        },

        'alpha': {
            globalEnabled: true,
            orgNames : ['integ-alpha-gbgroups-20160128-3', 'integ-alpha-iad-connect-20170830', 'onpremise-ad-large-20141117', 'gb-engg-alpha-20131219']
        },

        'beta': {
            globalEnabled: false,
            orgNames : []
        },

        'gamma': {
            globalEnabled: true,
            orgNames : ['da-test-sad']
        },

        // IAD
        'us-east-1': {
            globalEnabled: true,
            orgNames : []
        },

        // PDX
        'us-west-2': {
            globalEnabled: true,
            orgNames : ['test-auth-pdx', 'amazon']
        },

        // PDX Preview
        'us-west-2-prod-beta': {
            globalEnabled: true,
            orgNames : ['test-auth-pdx', 'amazon']
        },

        // DUB
        'eu-west-1': {
            globalEnabled: true,
            orgNames : []
        },

        // NRT
        'ap-northeast-1': {
            globalEnabled: true,
            orgNames : []
        },

        //PDT
        'us-gov-west-1': {
            globalEnabled: false,
            orgNames : []
        },

        // SYD
        'ap-southeast-2': {
            globalEnabled: true,
            orgNames : ['']
        },

        // FRA
        'eu-central-1': {
            globalEnabled: false,
            orgNames : ['']
        },

        // SIN
        'ap-southeast-1': {
            globalEnabled: true,
            orgNames : ['']
        }
};

    var NOT_SHOW_LOGIN_PAGE = {
        'dev': {
            orgNames : []
        },

        'alpha': {
            orgNames : ['guru-alpha-test']
        },

        'beta': {
            orgNames : []
        },

        'gamma': {
            orgNames : []
        },

        // IAD
        'us-east-1': {
            orgNames : ['secl-useast1']
        },

        // PDX
        'us-west-2': {
            orgNames : ['secl-uswest2']
        },

        // PDX Preview
        'us-west-2-prod-beta': {
            orgNames : []
        },

        // DUB
        'eu-west-1': {
            orgNames : ['secl-euwest1']
        },

        // NRT
        'ap-northeast-1': {
            orgNames : ['secl-apnortheast1']
        },

        // SYD
        'ap-southeast-2': {
            orgNames : []
        },

        // SIN
        'ap-southeast-1': {
            orgNames : ['secl-apsoutheast1']
        }
    };

    /**
     * LoginController is invoked the first time a user attempts to access a route that requires an
     * authenticated user.
     *
     * This controller will attempt to use an existing *refresh token*. If that call is successful
     * (i.e. the refresh token was still valid), then the user will just be "redirected" to the
     * requested route (found in `$routeParams`). Otherwise, store the requested route in a cookie
     * and redirect the user to the OAuth provider for login. The requested route will then be extracted
     * and used in the OAuth2CallbackController upon successful login.
     */
    function LoginController ($routeParams, $location, $window, $log, $rootScope : RootScope, authService, regionService, 
        endpointService, localStorageService, authenticatedUser, UserService, organizationService,
        AppConstants, ClientMetricsService, BrowserService, MetricEvents, oneTimeInitializationService: OneTimeInitializationService, $q, FeatureManagerService, Features) {
        const _EndpointConfig = (window as any)._EndpointConfig;
        activate();

        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate () {

            $log.debug(new Date().toISOString() + ' [LoginController] Initiating login flow');

            ClientMetricsService.startLatencyEvent(MetricEvents.LOGIN_PAGE_RENDER_START);

            if(authService.getAccessToken() !== null){
                $log.debug("The user is NOT authenticated but he has an access token, initializeUserInfo()");
                initializeUserInfo();
            } else if (authService.hasRefreshToken()) {
                $log.debug("The user is NOT authenticated but he has an refresh token, do refreshAccessToken()");
                authService.refreshAccessToken()
                .then(function () {
                    // We have a clean access token but we also need user info
                    $log.info(new Date().toISOString() + ' [LoginController] Got an access token! Now fetching user info');
                    initializeUserInfo();
                }, function () {
                    $log.debug("Could not refresh the access token inside LoginController");
                    // Couldn't refresh, so we redirect to the login flow
                    loginPage();
                });
            } else {
                $log.info(new Date().toISOString() + 'User has no refresh token. Redirecting to login page');
                loginPage();
                return;
            }
        }

        function initializeUserInfo() {

            authService.getUserInfo()
            .then(function () {
                // Success, we're done
                // Fetch user groups for later use
                authService.getUserGroups(authenticatedUser.getUserInfo().Id);
                $log.debug(new Date().toISOString() + ' [LoginController] Got user info! Let\'s go!');
                redirectFromLogin();
            }, function () {
                // Couldn't fetch user info, so we redirect to the login flow
                loginPage();
            });
        }

        function loginPage(){

            if(isShowSiteNotExistsInsteadOfLogin()){
                $log.info("Redirecting to Site Not Found Error page.");
                $rootScope.metricServiceInstance.putMetric({
                    MethodName: "LoginController.SiteNotExistsErrorPage",
                    MetricName: "Count",
                    Unit: "Count",
                    Values: 1
                });
                $location.url('/site_not_exists_error');
                return;
            }

            var isLoginV2Flow = false;
            //Reset site type
            localStorageService.set(AppConstants.AuthType.AUTH_TYPE, null);

            // Determine if LoginV2 flow is enabled for this region or for this Org in this region.
            isLoginV2Flow = isLoginV2Enabled();

            if(isLoginV2Flow) {
                //Use session storage to store site type
                $log.info(new Date().toISOString() + ' [LoginController] LoginV2 flow is enabled for this region or Org or browser.');
                localStorageService.set(AppConstants.AuthType.AUTH_TYPE, AppConstants.AuthType.AUTH_TYPE_LOGINV2);
                redirectToLogin(true);
                return;
            }

            // redirect to loginv2 endpoint for federated org
            organizationService.getOrganizationByAlias(endpointService.organization())
            .then(function(response) {
                const data = response.data;
                if (data.Mode == 'FEDERATED_IDENTITY') {
                    //Use session storage to store site type
                    $log.info(new Date().toISOString() + ' [LoginController] LoginV2 flow is enabled because this is a FEDERATED_IDENTITY site.');
                    localStorageService.set(AppConstants.AuthType.AUTH_TYPE, AppConstants.AuthType.AUTH_TYPE_LOGINV2);
                    redirectToLogin(true);
                    return;
                } else {
                    refreshOrRedirectForNonFederatedOrg();
                }
            }, function(response) {                
                // default to login v1
                if(response && response.data){
                    $log.info(new Date().toISOString() + ' [LoginController] Failed to call GetOrganizationByAlias: ' + response.data.Message);
                }
                refreshOrRedirectForNonFederatedOrg();
            });
        }

        function refreshOrRedirectForNonFederatedOrg() {
            //Since we determined the Login V2 is not applicable, remove the following entry from local storage
            localStorageService.remove(AppConstants.AuthType.AUTH_TYPE);
            if (authService.hasRefreshToken()) {
                authService.refreshAccessToken()
                .then(function () {
                    // We have a clean access token but we also need user info
                    $log.info(new Date().toISOString() + ' [LoginController] Got an access token! Now fetching user info');

                    authService.getUserInfo()
                        .then(function () {
                            // Success, we're done
                            $log.debug(new Date().toISOString() + ' [LoginController] Got user info! Let\'s go!');
                            redirectFromLogin();
                        }, function () {
                            // Couldn't fetch user info, so we redirect to the OAuth provider
                            redirectToLogin(false);
                        });
                }, function () {
                    // Couldn't refresh, so we redirect to the OAuth provider
                    redirectToLogin(false);
                });
            } else {
                $log.info(new Date().toISOString() + 'User has no refresh token. Redirecting to login page');
                redirectToLogin(false);
                return;
            }
        }

    /**
     * Returns the URL to which to return when login is successful
     */
        function getRedirectUrl () {
            var queryParam = $location.search();
            if (queryParam && queryParam.redirectPath) {
                return (queryParam.redirectPath || '').trim();
            }
            return null;
        }

        function isLoginV2Enabled() {
            var region, stage, orgName, retVal;

            // If user has opted in for new loginv2 flow, then return true.
            if (localStorageService.get(AppConstants.AuthType.LOGINV2_OPT_IN) == AppConstants.AuthType.LOGINV2_OPT_IN_TRUE) {
                $log.info(new Date().toISOString() + ' [LoginController] Determined that the user has opted in for LoginV2 flow in this browser.');
                return true;
            }

            retVal = false;
            region = regionService.getRegion();
            stage = endpointService.stageConfigKey(region);
            orgName = endpointService.organization();

            // Check if LoginV2 flow is enabled for this stage or for this Org in this Stage
            $log.debug(new Date().toISOString() + ' [LoginController] LoginV2 feature for stage : ' + stage + ' is : ' + JSON.stringify(LOGINV2_FEATURE_CONFIG[stage]));

            if (LOGINV2_FEATURE_CONFIG[stage] &&
                (LOGINV2_FEATURE_CONFIG[stage].globalEnabled === true || LOGINV2_FEATURE_CONFIG[stage].orgNames.indexOf(orgName) != -1)) {
                $log.info(new Date().toISOString() + ' [LoginController] Determined LoginV2 flow for Org : ' + orgName);
                retVal = true;
            }
            return retVal;
        }

        function redirectToLogin (isLoginV2Flow) {
            var region, stage, loginUrl, returnUrl;

            region = regionService.getRegion();
            stage = endpointService.stageConfigKey(region);

            if (isLoginV2Flow === true) {
                //Determine the app prefix
                var appPrefix = endpointService.appPrefix(stage);
                loginUrl = endpointService.loginV2Endpoint(stage) + '?sitename=' + encodeURIComponent(endpointService.organization()) + '&site_redirect_path=' + encodeURIComponent(appPrefix + '/index.html#/authSuccess');
            } else {
                loginUrl = endpointService.oauth2RedirectUrlBasedOnUserPreference(stage);
            }

            // Add the redirect URL as the state is present.
            returnUrl = getRedirectUrl();
            if (returnUrl) {
                //Use session storage to store the url
                try {
                    //Use session storage to store the url
                    $window.sessionStorage.setItem('wd_redirect_url', returnUrl);
                } catch (e) {
                    document.cookie = 'wd_redirect_url=' + returnUrl + ';';
                }
            }

            var renderStart = ClientMetricsService.getLatencyEventStartTime(MetricEvents.LOGIN_PAGE_RENDER_START);
            ClientMetricsService
                .recordLatencyEvent(MetricEvents.LOGIN_PAGE_RENDER_REDIRECTION, performance.now() - renderStart);
            ClientMetricsService.cancelLatencyEvent(MetricEvents.LOGIN_PAGE_RENDER_START);

            $rootScope.metricServiceInstance.putMetric({
                MethodName: "LoginController.RedirectToLogin",
                MetricName: "Count",
                Unit: "Count",
                Values: 1
            });

            //flushLogsToTheServer() is always resolved where as forcePostMetrics() is not. The identity will convert rejection to resolution
            $q.all([ClientMetricsService.flushLogsToTheServer(), $rootScope.metricServiceInstance.forcePostMetrics().then(null, _.identity)])
                .then(doTheRedirect, doTheRedirect);

            function doTheRedirect() {
                // IE does not handle page hash changes correctly. This is a known bug in IE and MS has indicated
                // that this will not be fixed. Refer : https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/3740423/
                // So. for IE we need to use the older solution.
                if(BrowserService.isIE()){
                    window.setTimeout(function() {
                        window.location.href = loginUrl;
                    });
                } else {
                    // note that we should not be setting href directly here because that causes a
                    // hash change and hence a new entry in the browser history which breaks navigation
                    // within workdocs site.
                    $window.location.replace(loginUrl);
                }
            }
        }

        function redirectFromLogin() {
            oneTimeInitializationService.initAll().then(redirectFromLoginImpl);
        }

        function redirectFromLoginImpl() {
            $log.info(new Date().toISOString() + 'Login successful, redirecting from login page');
            var returnUrl = '/mydocs',
                queryParam = $location.search(),
                redirectPath;

            if (queryParam && queryParam.redirectPath) {
                redirectPath = queryParam.redirectPath.trim();
                if(redirectPath && redirectPath.includes("document/")){
                    $rootScope.shouldHandlePdfLoadMetric = true;
                } else if (redirectPath && redirectPath.includes("shared")) {
                    $rootScope.sharedEntryPathMetric = true
                }
            }
            if (redirectPath) {
                if(!redirectPath.startsWith('/')){
                        returnUrl =  '/' + redirectPath;
                } else {
                    returnUrl = redirectPath;
                }
            }
            var flightNumber = _EndpointConfig.getFlightNumber();
            if (flightNumber) {
                $location.url(returnUrl).replace();
                return;
            }
            UserService.getUserPreferences(authenticatedUser.getUserInfo().Id)
            .then(function(userPref) {
                $log.info(new Date().toISOString() + 'Got preferences for user');
                $rootScope.displayMigrationModal = shouldSeeMigrationModal(userPref)
                redirectToUserPreferredVersion(returnUrl, userPref);
            }, function (data){
                redirectToUserPreferredVersion(returnUrl, undefined);
            });
        }

        function redirectToUserPreferredVersion (returnUrl, userPref) {

            $log.info(new Date().toISOString() + ' [LoginController] Entering redirect to preferred version');

            var redirectURL = $location.absUrl(),
                webVersion = getUserWebsitePreference(userPref),
                hasOptedOutFromNova = !!userPref && !!userPref.UserPreferences && userPref.UserPreferences.optoutNova === "true";

            redirectURL =  $location.protocol() + '://' + $location.host();

            // if a port is present; then add it to the URL.
            if($location.port()){
                redirectURL = redirectURL + ":" + $location.port();
            }

            redirectURL = redirectURL + window.location.pathname + "#" + returnUrl;
            const rainierPaths = RegExp(AppConstants.PreviewSite.PREVIEW_URL_COMPONENT + '|' + $rootScope.getRainierURL());
            const isNovaExperimentOn = FeatureManagerService.isFeatureEnabled(Features.UI.NOVA_ENABLED)
            const userOptedInForNova = webVersion === AppConstants.PreviewSite.WEB_NOVA_PREF;
            const userWasForcedIntoNova = $rootScope.isMemberOfGroup(AppConstants.NovaUsersForcedInGroup.BRAVEHEARTS) && !hasOptedOutFromNova;

            // defaulting to Nova only for amazon site user at this point.  https://i.amazon.com/WorkDocsWebX-4232
            const defaultWebVersion = isNovaExperimentOn && _EndpointConfig.isAmazonSite() ? AppConstants.PreviewSite.WEB_NOVA_PREF : AppConstants.PreviewSite.WEB_PROD_PREF;

            $log.info(new Date().toISOString() + ' [LoginController] Redirect url before user preference replacement : ' + redirectURL);

            if (isNovaExperimentOn && (userOptedInForNova || userWasForcedIntoNova)){
                    $log.info(new Date().toISOString() + ' [LoginController] Found user preference and user is set for Nova site.');
                    redirectURL = redirectURL.replace(rainierPaths, $rootScope.getNovaURL());
                    $log.info(new Date().toISOString() + ' [LoginController] Final redirect URL (Nova case) is :' + redirectURL);
            } else if (webVersion === null) {
                // if no web version preferences are set, set to default.
                UserService.updateUserPreferences(authenticatedUser.getUserInfo().Id, { 'webVersion': defaultWebVersion }).then(function () {
                    $log.info(new Date().toISOString() + ' [LoginController] Updated user preference to use ' + defaultWebVersion);
                });
                if (defaultWebVersion === AppConstants.PreviewSite.WEB_NOVA_PREF) {
                    redirectURL = redirectURL.replace(rainierPaths, $rootScope.getNovaURL());
                    $log.info(new Date().toISOString() + ' [LoginController] Final redirect URL (null case) is :' + redirectURL);
                }
            } else if (webVersion === AppConstants.PreviewSite.WEB_PREVIEW_PREF) {
                $log.info(new Date().toISOString() + ' [LoginController] Found user preference and user is set for preview site.');
                redirectURL = redirectURL.replace(rainierPaths, AppConstants.PreviewSite.PREVIEW_URL_COMPONENT);
                $log.info(new Date().toISOString() + ' [LoginController] Final redirect URL (preview case) is :' + redirectURL);
            } else if (userPref === null || userPref === undefined) {
                $log.info(new Date().toISOString() + ' [LoginController] No user preferences set for user.');

                // if no preferences are set, set to default.
                UserService.updateUserPreferences(authenticatedUser.getUserInfo().Id, { 'webVersion': defaultWebVersion }).then(function () {
                    $log.info(new Date().toISOString() + ' [LoginController] Updated user preference to use ' + defaultWebVersion);
                });
                if (defaultWebVersion === AppConstants.PreviewSite.WEB_NOVA_PREF) {
                    redirectURL = redirectURL.replace(rainierPaths, $rootScope.getNovaURL());
                    $log.info(new Date().toISOString() + ' [LoginController] Final redirect URL (null case) is :' + redirectURL);
                }
            } else {
                // if the user is trying to go to preview url put them back in prod url.
                if (redirectURL.indexOf(AppConstants.PreviewSite.PREVIEW_URL_COMPONENT) !== -1) {
                    $log.info(new Date().toISOString() + ' [LoginController] User Preference indicates production but accessed site is preview');
                    redirectURL = redirectURL.replace(rainierPaths, AppConstants.PreviewSite.PROD_URL_COMPONENT);
                }

                $log.info(new Date().toISOString() + ' [LoginController] Final redirect URL (production case) is :' + redirectURL);
            }

            var renderStart = ClientMetricsService.getLatencyEventStartTime(MetricEvents.LOGIN_PAGE_RENDER_START);
            ClientMetricsService
                .recordLatencyEvent(MetricEvents.LOGIN_PAGE_RENDER_COMPLETE, performance.now() - renderStart);
            ClientMetricsService.cancelLatencyEvent(MetricEvents.LOGIN_PAGE_RENDER_START);
            //flushLogsToTheServer() is always resolved where as forcePostMetrics() is not. The identity will convert rejection to resolution
            $q.all([ClientMetricsService.flushLogsToTheServer(), $rootScope.metricServiceInstance.forcePostMetrics().then(null, _.identity)])
                .then(doTheRedirect, doTheRedirect);

            function doTheRedirect() {
                // IE does not handle page hash changes correctly. This is a known bug in IE and MS has indicated
                // that this will not be fixed. Refer : https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/3740423/
                // So. for IE we need to use the older solution.
                if(BrowserService.isIE()){
                    window.setTimeout(function() {
                        window.location.href = redirectURL;
                    });
                } else {
                    // note that we should not be setting href directly here because that causes a
                    // hash change and hence a new entry in the browser history which breaks navigation
                    // within workdocs site.
                    $window.location.replace(redirectURL);

                }
            }
        }

        function getUserWebsitePreference(userPref)
        {
            var preferredVersion = null;

            if(userPref && userPref.UserPreferences){
                if(userPref.UserPreferences.webVersion){
                    preferredVersion = userPref.UserPreferences.webVersion;
                    $log.info(new Date().toISOString() + ' [LoginController] Updated user website preference value to : ' + preferredVersion);
                }
            }
            $log.info(new Date().toISOString() + ' [LoginController] User website version preference value is : ' + preferredVersion);
            return preferredVersion;
        }

        function isShowSiteNotExistsInsteadOfLogin() {
            var region, stage, orgName, retVal;

            retVal = false;
            region = regionService.getRegion();
            stage = endpointService.stageConfigKey(region);
            orgName = endpointService.organization();

            // Check if this is enabled for the stage or for this Org in this Stage
            $log.debug(new Date().toISOString() + ' [LoginController] ShowSiteNotExistsInsteadOfLogin feature for stage : ' + stage + ' is : ' + JSON.stringify(NOT_SHOW_LOGIN_PAGE[stage]));

            if (NOT_SHOW_LOGIN_PAGE[stage] && NOT_SHOW_LOGIN_PAGE[stage].orgNames.indexOf(orgName) !== -1) {
                $log.info(new Date().toISOString() + ' [LoginController] Determined ShowSiteNotExistsInsteadOfLogin flow for Org : ' + orgName);
                retVal = true;
            }
            return retVal;
        }

        function shouldSeeMigrationModal(userPref) {
            if(userPref && userPref.UserPreferences.acknowledgedMigrationModalPostSunset === 'true'){
                return false;
            }
            return true;
        }
}
